import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import PriceComparisonReportActions from "../../../../reducers/modules/report/price-comparison/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "report/price-comparison";

export default class PriceComparisonReportMiddleware {
  
  static reset() {
    return (dispatch) => {
      dispatch(PriceComparisonReportActions.reset());
    };
  }
  static Tracking(post) {
    return (dispatch) => {
      dispatch(PriceComparisonReportActions.process());
      PriceComparisonReportMiddleware.showTracking(post,dispatch);
    };
  }

  static getPrintSelling(params) {
      return (dispatch) => {
        dispatch(PriceComparisonReportActions.beforePrintSelling());
        PriceComparisonReportMiddleware.showPrintSelling(dispatch, params);
      };
    }

  static getPrintPurchasing(params) {
      return (dispatch) => {
        dispatch(PriceComparisonReportActions.beforePrintPurchasing());
        PriceComparisonReportMiddleware.showPrintPurchasing(dispatch, params);
      };
    }
  
  static getHelper(params = null) {
    return (dispatch) => {
      PriceComparisonReportMiddleware.showHelper(dispatch, params);
    };
  }

  
  static getToken() {
    return cookieManager.getUserToken();
  }

  static getDataSelling(post){
    return (dispatch) => {
      dispatch(PriceComparisonReportActions.process());
      PriceComparisonReportMiddleware.showDataSelling(post,dispatch);
    };
  }

  static getDataPurchasing(post){
    return (dispatch) => {
      dispatch(PriceComparisonReportActions.process());
      PriceComparisonReportMiddleware.showDataPurchasing(post,dispatch);
    };
  }


  static showPrintSelling(dispatch, params) {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${PriceComparisonReportMiddleware.getToken()}`,
        },
        url: process.env.REST_URL +'report/price-comparison/print/selling',
        responseType: "json",
        data:params
      })
        .then((response) => {
          if (response && response.status === 200 && response.data) {
            console.log('RESPONSE',response.data)
            dispatch(PriceComparisonReportActions.printSelling(response.data.result));
          }
        })
        .catch((error) => {
          PriceComparisonReportMiddleware.alertHendler(dispatch, error);
        });
    }
    
    static showPrintPurchasing(dispatch, params) {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${PriceComparisonReportMiddleware.getToken()}`,
        },
        url: process.env.REST_URL +'report/price-comparison/print/purchasing',
        responseType: "json",
        data:params
      })
        .then((response) => {
          if (response && response.status === 200 && response.data) {
            dispatch(PriceComparisonReportActions.printPurchasing(response.data.result));
          }
        })
        .catch((error) => {
          PriceComparisonReportMiddleware.alertHendler(dispatch, error);
        });
    }

  static showDataSelling(params,dispatch){
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PriceComparisonReportMiddleware.getToken()}`,
      },
      url:process.env.REST_URL+'report/price-comparison-show/selling' ,
      responseType: "json",
      data: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PriceComparisonReportActions.setDataSelling(response.data.result));
        }
      })
      .catch((error) => {
        PriceComparisonReportMiddleware.alertHendler(dispatch, error);
      });
  }

  static showDataPurchasing(params,dispatch){
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PriceComparisonReportMiddleware.getToken()}`,
      },
      url:process.env.REST_URL+'report/price-comparison-show/purchasing' ,
      responseType: "json",
      data: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PriceComparisonReportActions.setDataPurchasing(response.data.result));
        }
      })
      .catch((error) => {
        PriceComparisonReportMiddleware.alertHendler(dispatch, error);
      });
  }

  static showTracking(params,dispatch) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PriceComparisonReportMiddleware.getToken()}`,
      },
      url:process.env.REST_URL+'report/tracking-sales-show' ,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PriceComparisonReportActions.setTracking(response.data.result));
        }
      })
      .catch((error) => {
        PriceComparisonReportMiddleware.alertHendler(dispatch, error);
      });
  }

  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PriceComparisonReportMiddleware.getToken()}`,
      },
      url:process.env.REST_URL+'helper/get-helper-sales-report' ,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          console.log(response)
          dispatch(PriceComparisonReportActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        PriceComparisonReportMiddleware.alertHendler(dispatch, error);
      });
  }
 
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    console.log(result)
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(PriceComparisonReportActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(PriceComparisonReportActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
